const fileDownloadIcon = `
    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22">
      <g fill="none" fill-rule="evenodd" transform="translate(1 1)">
        <g stroke="#C9CCCD" stroke-linejoin="round">
          <g transform="translate(9.167 9.167)">
            <polyline stroke-linecap="round" points="3.333 5.833 5.417 7.917 7.5 5.833"/>
            <circle cx="5.417" cy="5.417" r="5"/>
            <path stroke-linecap="round" d="M5.41666667,2.91666667 L5.41666667,7.91666667"/>
          </g>
          <g stroke-linecap="round">
            <path d="M2.91666667 5.41666667L6.66666667 5.41666667M2.91666667 7.91666667L9.58333333 7.91666667M2.91666667 10.4166667L7.91666667 10.4166667M2.91666667 12.9166667L7.08333333 12.9166667"/>
            <polyline points="8.75 17.917 .417 17.917 .417 .417 9.583 .417 13.75 4.583 13.75 7.917"/>
            <polyline points="9.583 .417 9.583 4.583 13.75 4.583"/>
          </g>
        </g>
        <rect width="20" height="20"/>
      </g>
    </svg>

    `;

export default fileDownloadIcon;
